var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c(
        "el-form",
        {
          ref: "sendForm",
          attrs: {
            model: _vm.sendForm,
            rules: _vm.rules,
            "label-position": "top"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "username 通过动态路由匹配发送",
                prop: "username"
              }
            },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                model: {
                  value: _vm.sendForm.username,
                  callback: function($$v) {
                    _vm.$set(_vm.sendForm, "username", $$v)
                  },
                  expression: "sendForm.username"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "userid 通过参数发送", prop: "userid" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                model: {
                  value: _vm.sendForm.userid,
                  callback: function($$v) {
                    _vm.$set(_vm.sendForm, "userid", $$v)
                  },
                  expression: "sendForm.userid"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("sendForm")
                    }
                  }
                },
                [_vm._v("跳转到接收页面")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }